module.exports = __webpack_public_path__ + "img/congrats-banner.4eac605e.jpg";